







































































import { EmployeApi } from "../../api/EmployeApi";
// @ts-ignore
import VueCal from "vue-cal";
import moment from "moment";
import PlanningTablePreview from "./PlanningTablePreview.vue";
import { InterventionApi } from "../../api/InterventionApi";
export default {
    name: "PlanningPreview",
    components: { PlanningTablePreview, VueCal },
    props: {
        employeId: Number,
    },
    data() {
        return {
            calendarView: true,
            workingHours: [],
            interventions: [],
            timeCellHeight: 50,
            employe: null,
            EmployeApi: new EmployeApi(),
            InterventionApi: new InterventionApi(),
            selectedDate: moment().format("YYYY-MM-DD"),
            planningId: null,
            showInterventions: false,
        };
    },
    created() {
        let self = this;
        if (self.employeId) {
            self.refreshPlanning();
            self.EmployeApi.get(self.employeId).then(function (employe) {
                self.employe = employe;
            });
        }
    },
    methods: {
        toggleView() {
            this.calendarView = !this.calendarView;
        },
        refreshPlanning() {
            let self = this;
            self.getPlanning(self.selectedDate);
            self.getInterventions(self.selectedDate);
        },
        getPlanning(date) {
            let self = this;
            self.EmployeApi.getPlanningByDate(self.employeId, date).then(
                function (planning) {
                    self.planningId = planning.planning_id;
                    self.workingHours = _.map(
                        planning.planning_working_hours,
                        function (wh) {
                            return wh.toEvent(date);
                        }
                    );
                }
            );
        },
        getInterventions(date) {
            let self = this;

            let startDateStr = moment(date)
                .startOf("week")
                .format("YYYY-MM-DD");
            let endDateStr = moment(date).endOf("week").format("YYYY-MM-DD");

            return self.InterventionApi.getAll({
                // get employe planning
                datePrevueFrom: startDateStr,
                datePrevueTo: endDateStr,
                programmed: true,
                employeIds: self.employeId,
                withAsPlanned: true,
                withHorairesSet: true,
                limit: 100000,
            }).then(function (response) {
                let { data, metadata, paginator } = response;
                self.interventions = [];
                _.forEach(data, function (i) {
                    let startTimeStr =
                        i.date_prevue_intervention +
                        " " +
                        (i.horaire_debut
                            ? i.horaire_debut.replace("h", ":")
                            : "08:00");
                    let endTimeStr =
                        i.date_prevue_intervention +
                        " " +
                        (i.horaire_fin
                            ? i.horaire_fin.replace("h", ":")
                            : "08:30");
                    self.interventions.push({
                        start: startTimeStr,
                        end: endTimeStr,
                        title: i.client ? i.client.nom : "",
                        content: i.titre,
                        class: "intervention",
                    });
                });
            });
        },
        onCalendarEvent(event) {
            let self = this;

            if (event.view === "week") {
                this.selectedDate = moment(event.startDate).format(
                    "YYYY-MM-DD"
                );
                self.refreshPlanning();
                // Scroll view
                setTimeout(function () {
                    let calendar = document.querySelector(
                        "#vuecal-employe .vuecal__bg"
                    );
                    calendar.scrollTo({
                        top: 6 * self.timeCellHeight,
                        behavior: "smooth",
                    });
                }, 500);
            }
        },
        toggleInterventions() {
            this.showInterventions = !this.showInterventions;
        },
        printTable() {
            let self = this;
            let table = document.getElementById("working-hours-table");
            let newWin = window.open("");
            newWin.document.write(
                "<html><head>" +
                    document.head.innerHTML +
                    "</head>" +
                    "<body style='background: white !important;'>" +
                    "<h3>" +
                    (self.employe ? self.employe.fullName : "") +
                    "</h3>" +
                    table.outerHTML +
                    "<p>Planning donné à titre indicatif pouvant être modifié sans préavis par la Direction selon les besoins de l'activité</p>" +
                    "</body>" +
                    "</html>"
            );
            setTimeout(function () {
                newWin.stop();
                newWin.print();
                newWin.close();
            }, 1000);
        },
    },
    computed: {
        events: function () {
            return this.workingHours.concat(this.interventions);
        },
    },
};
